module.exports = {
      id: "share-whatsapp-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#share-whatsapp",
      toString: function () {
        return this.url;
      }
    }